// A rejected assignment change answers with `{ errors: [{ memberGuid | assignmentId, reason }] }`,
// where `reason` is already translated and a request-level rule repeats it for every offending
// entry. One toast carries one message, so a failure is only described by its reason when every
// entry shares it — naming one entry's reason out of several would imply it is the only problem.
export function resolveAssignmentFailureReason(payload: unknown): string | null {
  const errors = (<{ error?: { errors?: unknown } }>payload)?.error?.errors;

  const messages = Array.isArray(errors)
    ? errors
        .map(entry => (typeof entry === 'string' ? entry : (<{ reason?: string }>entry)?.reason))
        .filter((message): message is string => !!message)
    : [];

  const distinctMessages = [...new Set(messages)];

  return distinctMessages.length === 1 ? distinctMessages[0] : null;
}
